//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { decodeHTMLEntities } from '@/utils/tools';

export default {
  name: 'UsePluginDropdown',
  props: {
    pluginId: {
      type: [Number, String],
      required: true,
    },
    editorType: {
      type: String,
      default: 'canvas', // 'devMode' 时按研发模式筛选文件
    },
    isInstalled: {
      type: Boolean,
      required: false,
    },
    maxFiles: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      recentFiles: [],
      pending: false,
      loadingRecent: false,
      fileTypes: {
        DEV: 0,
        PROTOTYPE: 1,
      },
    };
  },
  computed: {
    isDevModePlugin() {
      return this.editorType === 'devMode' || this.editorType === 'canvas/devMode';
    },
    canUse() {
      return this.isInstalled;
    },
  },
  methods: {
    decodeHTMLEntities,
    filterFiles(data) {
      const editableFiles = (data || []).filter(
        (item) => item.permissions && item.permissions['edit-without-seat'] === true,
      );
      // 研发模式只存在于设计文件
      const editableDevModeFiles = (data || []).filter(
        (item) => item.permissions && item.permissions['use-dev-mode'] === true && item.fileMode === 0,
      );
      return this.isDevModePlugin
        ? editableDevModeFiles.slice(0, this.maxFiles)
        : editableFiles.slice(0, this.maxFiles);
    },
    async fetchRecentFiles() {
      // 仅在首次点击时请求，且避免并发重复请求
      if (this.loadingRecent) return;
      this.loadingRecent = true;
      try {
        const currentSpace = localStorage.getItem('currentSpace') || 0;
        const { data } = await this.$axios.$post(
          '/api/v1/users/recent',
          {
            entityIds: [],
            sort: '-open_at',
            entityType: currentSpace ? 'org' : 'team',
            organizationId: Number(currentSpace),
          },
          {
            headers: {
              OrganizationId: Number(currentSpace),
            },
          },
        );
        this.recentFiles = this.filterFiles(data);
      } catch (e) {
        // 静默失败，避免影响页面其它逻辑
        this.recentFiles = [];
      } finally {
        this.loadingRecent = false;
      }
    },
    setPluginData() {
      localStorage.setItem(
        'temporary_community_openfile_data',
        JSON.stringify({
          pluginId: this.pluginId,
          devMode: this.isDevModePlugin,
        }),
      );
    },
    async openFile(item) {
      if (this.pending) return;
      this.pending = true;
      try {
        // 1. 获取邀请ID
        const inviteResponse = await this.$axios.$post(`${window.location.origin}/api/v1/project/link-invite`, {
          documentId: item.id,
        });
        const { inviteDataId, inviteBatchId } = inviteResponse.data || {};

        // 2. 获取短链接
        const filePrefix = item.fileMode === this.fileTypes.DEV ? 'file' : 'prototyping';
        const longUrl = `${window.location.origin}/${filePrefix}/${item.id}?inviteDocumentId=${inviteDataId}&inviteBatchId=${inviteBatchId}`;
        const shortlinkResponse = await this.$axios.$post(`${window.location.origin}/api/v1/tools/shortlink`, {
          url: longUrl,
          reserved: `file=${item.id}`,
        });

        // 3. 打开文件并设置临时数据
        window.open(shortlinkResponse.data.shortUrl, '_blank');
        this.setPluginData();
      } catch (error) {
        this.$message.error('文件打开失败，请重试');
      } finally {
        this.pending = false;
      }
    },
    createFile(type) {
      this.setPluginData();
      const url = `${window.location.origin}/files/home?action=create&fileMode=${type}`;
      window.open(url);
    },
  },
};
